<template>
    <el-container v-loading="isShowLoading">
        <el-main> 
            <el-row>
                <el-form :model="filterData" :inline="true">
                    <el-form-item>
                        <el-input v-model="filterData.agencyCode" placeholder="请输入开票单位代码"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="filterData.agencyName" placeholder="请输入开票单位名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="filterData.businessCode" placeholder="请选择业务">
                            <el-option v-for="item in businessCodeOptions" :key="item.mc" :label="item.mc" :value="item.dm">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="filterData.einvoiceTypeCode" placeholder="请选择票据种类">
                            <!-- <el-option label="--票据种类选择--" value=""></el-option> -->
                            <el-option v-for="item in einvoiceTypeOptions" :key="item.mc" :label="item.mc" :value="item.dm">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="filterData.einvoiceSourceCode" placeholder="请选择票据来源">
                            <!-- <el-option label="--票据来源选择--" value=""></el-option> -->
                            <el-option v-for="item in einvoiceSourceOptions" :key="item.mc" :label="item.mc" :value="item.dm">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="filterData.einvoiceYear" placeholder="请选择年度">
                            <!-- <el-option label="--年度选择--" value=""></el-option> -->
                            <el-option v-for="item in yearOptions" :key="item.value" :label="item.value" :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="filterData.einvoiceMonth" placeholder="请选择月度">
                            <!-- <el-option label="--月度选择--" value=""></el-option> -->
                            <el-option v-for="item in monthOptions" :key="item.value" :label="item.value" :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="onFilter">查询</el-button>
                        <el-button type="primary" size="small" icon="el-icon-refresh-left" @click="reset">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="exportExcel">导出</el-button>
                </el-col>
            </el-row>
            <el-table  ref="singleTable" :data="recordData" highlight-current-row style="width: 100%" :height="tableHeight"  @row-dblclick="onRowDblclick"
			:header-cell-style="{background:'#f5f7fa', color: 'black'}" border :stripe="stripeVisible">
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column property="agencyCode" label="单位代码" width="150" show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="agencyName" label="单位名称" width="150" show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="businessName" label="业务名称" width="100" show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="einvoiceTypeName" label="票据种类" width="190" show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="einvoiceSourceName" label="票据来源" width="120"></el-table-column>
                <el-table-column property="einvoiceMonth" label="年度月份" width="80"></el-table-column>
                <el-table-column property="totalAmountBlueEinv" label="开票总金额（蓝票）" width="150"></el-table-column>
                <el-table-column property="totalQuantityBlueEinv" label="开票总数量（蓝票）" width="150"></el-table-column>
                <el-table-column property="totalAmountRedEinv" label="开票总金额（红票）" width="150"></el-table-column>
                <el-table-column property="totalQuantityRedEinv" label="开票总数量（红票）" width="150"></el-table-column>
            </el-table>
            
            <el-row style="margin: 18px 8px">
                <el-col :span="24">
                    <pagination v-show="pagination.total/pagination.pageSize>1" layout="total, sizes, prev, pager, next, jumper"
                        :total="pagination.total" :page.sync="pagination.page" :limit.sync="pagination.pageSize"
                        @pagination="onFilter" />
                </el-col>
            </el-row>
        </el-main>
    </el-container>
</template>

<script>
    let _kits, _table, _tableExport
    export default {
        components: {
        },
        data() {
            return {
                isShowLoading: true,
                isShowItem: false,
                //pageWidth: 600,
                //页面布局相关
                layout: {
                    loading: true,
                    width: 600,
                    wd: "80%",
                    edit: false
                },
                //数据绑定相关
                filterData: {}, //过滤信息
                recordData: [], //展示信息
                einvoiceSourceOptions:[],
                einvoiceTypeOptions:[],
                businessCodeOptions:[],
                yearOptions:[],
                monthOptions:[],
                pagination: {
                    total: 0,
                    page: 1,
                    pageSize: 10
                }, //分页信息
                entityData: {} //具体某一项信息
            }
        },
        methods: {
            reset(){
                this.filterData = {};
            },
            exportExcel() {
                _kits.confirm({
                    text: "确定导出?",
                    yes: () => {
                        this.layout.loading = true
                        _kits.message("正在导出")
                        _kits.api.call(
                            "QUERYEINVREPORTMONTHLISTEXPORT", {
                                "agencyName": this.filterData.agencyName,
                                "agencyCode": this.filterData.agencyCode,
                                "businessCode": this.filterData.businessCode,
                                "einvoiceTypeCode": this.filterData.einvoiceTypeCode,
                                "einvoiceSourceCode": this.filterData.einvoiceSourceCode,
                                "einvoiceYear": this.filterData.einvoiceYear,
                                "einvoiceMonth": this.filterData.einvoiceMonth,
                                "sheetName": "einvMonth",
                                "cellName":"序号|单位代码|单位名称|票据种类|票据来源|年度月份|开票总金额（蓝票）|开票总数量（蓝票）|开票总金额（红票）|开票总数量（红票）",
                                "cellNameCode":"rowNum|agencyCode|agencyName|einvoiceTypeName|einvoiceSourceName|einvoiceMonth|totalAmountBlueEinv|totalQuantityBlueEinv|totalAmountRedEinv|totalQuantityRedEinv"
                            },
                            function (result) {
                                if (result.returnCode == "0000") {
                                    console.log(result);
                                    //alert(result.data.servletpath);
                                    let a = document.createElement("a");
                                    a.download = result.data.fileName;
                                    //let data_head = "data:;base64,";
                                    //a.href = data_head + result.data.fileBase64;
                                    a.href = result.data.servletpath;
                                    document.querySelector("body").appendChild(a);
                                    a.click();
                                    document.querySelector("body").removeChild(a);
                                } else {
                                    this.$message.error(result.returnMsg);
                                }
                            }
                        )
                    }
                })
            },
            onRowDblclick(row, column, event) {
                console.log(row)
            },
            onFilter() {
                console.log(_kits.data("filterData"))
                this.layout.loading = true
                _table.load()
            },
            init() {
                _table.load()   
            },
            back() {
                //console.log("back")
                this.layout.edit = false
            }
        },
        created() {
            //this.pageWidth = window.innerWidth - 200
            _kits = this.$kits()
            _kits.api.call(
                "GETCOLLECTION", {
                   "collectionId": "einvoiceSourceCollection"//票据来源下拉框
                },
                result => {
                    if (result.returnCode == "0000") {
                        console.log(result.data);
                        this.einvoiceSourceOptions = result.data;
                    } else {
                        this.$message.error(result.returnMsg);
                    }
                }
            );
            _kits.api.call(
                "GETCOLLECTION", {
                   "collectionId": "einvoiceTypeCollection"//票据种类下拉框
                },
                result => {
                    if (result.returnCode == "0000") {
                        console.log(result.data);
                        this.einvoiceTypeOptions = result.data;
                    } else {
                        this.$message.error(result.returnMsg);
                    }
                }
            );
            _kits.api.call(
                "GETCOLLECTION", {
                   "collectionId": "businessCollection"//业务代码下拉框
                },
                result => {
                    if (result.returnCode == "0000") {
                        console.log(result.data);
                        this.businessCodeOptions = result.data;
                    } else {
                        this.$message.error(result.returnMsg);
                    }
                }
            );
            _kits.api.call(
                "GETCOLLECTIONYEAR", {
                  // "collectionId": "einvoiceTypeCollection"//年度下拉框
                },
                result => {
                    if (result.returnCode == "0000") {
                        this.yearOptions = result.data;
                    } else {
                        this.$message.error(result.returnMsg);
                    }
                }
            );
            _kits.api.call(
                "GETCOLLECTIONMONTH", {
                  // "collectionId": "einvoiceTypeCollection"//月度下拉框
                },
                result => {
                    if (result.returnCode == "0000") {
                        this.monthOptions = result.data;
                    } else {
                        this.$message.error(result.returnMsg);
                    }
                }
            );
            _table = _kits.table(
                "QUERYEINVREPORTMONTHLIST",
                () => {
                    return Object.assign({}, this.filterData, this.pagination)
                },
                result => {
                    this.isShowLoading = false
                    this.recordData = result.list
                    this.pagination.total = Number.parseInt(result.total)
                }
            )
            this.init()
        },
        mounted() {}
    }
</script>
<style scoped>
</style>
